import React, { Component } from 'react'
import { SecureContainer, FormSelect, FormInput, Modal } from '../../components'
import countries from 'countries-cities'
import { newOrganization } from '../../api';
import { replace } from '../../actions/nav-actions';
import { notify } from '../../utils'
import { connect } from 'react-redux'

class CreateOrganization extends Component {
    state = {
        countries: countries.getCountries().map(option => ({ label: option, value: option })),
        name: '',
        admin_name: '',
        admin_email: '',
        country: '',
        organization: {}
    }
    onSubmit(event) {
        event.preventDefault();
        let { name, admin_name, admin_email, country } = this.state;
        newOrganization({ name, admin_name, admin_email, country })
            .then((organization) => {
                this.setState({ organization })
            })
            .catch(err => notify('Error', err.message, 'error'))
    }
    render() {
        return (
            <SecureContainer title="New Organization">
                <form onSubmit={this.onSubmit.bind(this)}>
                    <FormInput
                        onChange={(text) => {
                            this.setState({ name: text })
                        }}
                        required
                        placeholder="Name of the Organization" />
                    <FormInput
                        onChange={(text) => {
                            this.setState({ admin_name: text })
                        }}
                        required
                        placeholder="Name of primary POC/administrator" />
                    <FormInput
                        onChange={(text) => {
                            this.setState({ admin_email: text })
                        }}
                        required
                        placeholder="Email of primary POC/administrator" />
                    <FormSelect
                        onChange={(option) => {
                            let { country } = this.state;
                            country = option.label;
                            this.setState({ country });
                        }}
                        placeholder="Countries"
                        searchable required
                        value={this.state.country}
                        options={this.state.countries} />
                    <button type="submit" className="btn btn-info btn-block" style={{ marginTop: '24px' }}>CREATE ORGANIZATION</button>
                </form>
                <Modal
                    title="ORGANIZATION CODE"
                    visible={!!this.state.organization.code}
                    hideActions={true}>
                    <FormInput
                        readOnly
                        className="form-control text-center"
                        value={this.state.organization.code} />
                    <div className="text-center" style={{ marginTop: '24px', marginBottom: '24px' }}>
                        <span>We have sent an you email with your Organization Code</span>
                    </div>
                    <button
                        className="btn btn-info btn-block"
                        onClick={() => {
                            this.props.replace(`/create-account/${this.state.organization.code}`);
                        }}>
                        CREATE NEW USER
                    </button>
                </Modal>
            </SecureContainer>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    replace(routeName) {
        dispatch(replace(routeName));
    }
})

export default connect(null, mapDispatchToProps)(CreateOrganization);


// WEBPACK FOOTER //
// ./src/routers/CreateOrganization/index.js